import React, { useId } from 'react';
import './FilterDateGroup.css';

/**
 * Composant réutilisable pour les groupes date + label
 * @param {string} label - Texte du label (ex: "Date début", "Date fin")
 * @param {string} name - Nom du champ
 * @param {string} value - Valeur contrôlée
 * @param {function} onChange - Fonction appelée au changement
 * @param {string} className - Classes CSS supplémentaires
 * @param {string} id - ID unique pour l'input (optionnel, généré automatiquement si non fourni)
 */
const FilterDateGroup = ({
  label,
  name,
  value,
  onChange,
  className = '',
  id,
}) => {
  const generatedId = useId();
  const inputId = id || generatedId;
  const groupClass = `filter-date-group ${className}`.trim();

  return (
    <div className={groupClass}>
      <label htmlFor={inputId} className="filter-date-label">{label}</label>
      <input
        type="date"
        id={inputId}
        name={name}
        value={value}
        onChange={onChange}
        className="filter-date-input"
      />
    </div>
  );
};

export default FilterDateGroup;

